import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getPublisherAction = createAsyncThunk(
    'get-publisher-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/publisher-detials`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPublisherSlice = createSlice({
    name: 'get-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPublisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPublisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPublisherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getPublisherReducer = getPublisherSlice.reducer